import arePositionsEqual from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/Helpers/arePositionsEqual';
import parseInstancePositions from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/Helpers/parseInstancePositions';
import type DocumentListEntryView from '@UI/Store/Documents/Views/DocumentListEntryView';
import type { DocumentEntryView } from '@UI/Store/Documents/Views/buildDocumentEntryView';
import type { ViewerFieldInfo } from '@verclam/docx-kit-editor';

const collectFieldUuids = (entries: readonly DocumentEntryView[], uuids: Set<string>): void => {
	for (const entry of entries) {
		if (entry.type === 'field') {
			uuids.add(entry.uuid);
		} else if (entry.type === 'group') {
			collectFieldUuids(entry.entries, uuids);
		} else {
			for (const item of entry.items) {
				collectFieldUuids(item.entries, uuids);
			}
		}
	}
};

/**
 * The instance path the viewer names a list element by, read off `handle.fields()` rather than
 * composed: the path of the first occurrence of a field this list carries whose positions are those of
 * the element. `null` when no field of the element is displayed (a list of scalars, or an element whose
 * fields are all hidden) — the caller then does not scroll.
 */
const findViewerItemPath = (
	fields: readonly ViewerFieldInfo[],
	list: DocumentListEntryView,
	containerPositions: readonly number[],
	itemIndex: number,
): string | null => {
	const listFieldUuids = new Set<string>();
	collectFieldUuids(
		list.items.flatMap((item) => item.entries),
		listFieldUuids,
	);

	const wanted = [...containerPositions, itemIndex];

	for (const field of fields) {
		if (!listFieldUuids.has(field.id) && field.list?.id !== list.uuid) {
			continue;
		}

		for (const occurrence of field.occurrences) {
			if (
				occurrence.path !== undefined &&
				arePositionsEqual(parseInstancePositions(occurrence.path), wanted)
			) {
				return occurrence.path;
			}
		}
	}

	return null;
};

export default findViewerItemPath;
